"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { CircleCheckIcon, Loader2Icon, XIcon } from "lucide-react";

import { FeedbackStatusIcon } from "@/lib/feedbackVariants";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-center"
      className="toaster group"
      closeButton
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        error: <FeedbackStatusIcon variant="error" className="size-4" />,
        warning: <FeedbackStatusIcon variant="warning" className="size-4" />,
        info: <FeedbackStatusIcon variant="info" className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
        close: <XIcon className="size-3.5" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast:
            "cn-toast group-[.toaster]:bg-popover group-[.toaster]:pr-10 group-[.toaster]:text-popover-foreground group-[.toaster]:border-border",
          title: "group-[.toast]:text-foreground",
          description: "group-[.toast]:text-muted-foreground",
          success: "!border-l-[3px] !border-l-emerald-500 [&_[data-icon]]:text-emerald-500",
          error:
            "!border-l-[3px] !border-l-red-500 [&_[data-icon]]:text-red-500 dark:!border-l-red-400 dark:[&_[data-icon]]:text-red-400",
          warning: "!border-l-[3px] !border-l-amber-500 [&_[data-icon]]:text-amber-500",
          info: "!border-l-[3px] !border-l-primary [&_[data-icon]]:text-primary",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
